// Copyright (C) 2024 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import './styles.scss';
import { useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { CombinedState, Indexable } from 'reducers';
import { useHistory } from 'react-router';
import Button from 'antd/lib/button';

import Spin from 'antd/lib/spin';

import { updateHistoryFromQuery } from 'components/resource-sorting-filtering';
import EmptyListComponent from './empty-list';
import RequestsList, { PAGE_SIZE } from './requests-list';

export default function RequestsPageComponent(): JSX.Element {
    const history = useHistory();
    const { fetching, query, requests } = useSelector((state: CombinedState) => state.requests);

    const count = Object.keys(requests).length;
    console.log('RequestsPageComponent', { fetching, query, count, requests });
    const updatedQuery = { ...query };
    const queryParams = new URLSearchParams(history.location.search);
    for (const key of Object.keys(updatedQuery)) {
        (updatedQuery as Indexable)[key] = queryParams.get(key) || null;
        if (key === 'page') {
            updatedQuery.page = updatedQuery.page ? +updatedQuery.page : 1;
        }
    }

    useEffect(() => {
        history.replace({
            search: updateHistoryFromQuery(query),
        });
    }, [query]);

    const pageOutOfBounds = updatedQuery.page ? updatedQuery.page > Math.ceil(count / PAGE_SIZE) : false;
    const hasExportDownloads = Object.values(requests).some(
            (r: any) => r.action === 'export' && r.active && r.file,
        );

        const content = (count && !pageOutOfBounds)
            ? <RequestsList query={updatedQuery} count={count} />
            : <EmptyListComponent />;



    function handleBulkDownload(): void {
        const exportRequests = Object.values(requests).filter((request: any) =>
            request.status === 'finished' && request.url
        );

        exportRequests.forEach((request: any) => {
            const link = document.createElement('a');
            link.href = request.url;
            link.download = request.url.split('/').pop() || 'export.zip';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }

    return (
        <div className='cvat-requests-page'>
            {fetching ? (
                <div>
                    <Spin size='large' className='cvat-spinner' />
                </div>
            ) : (
                <>
                    {content}
                    {count > 0 && !pageOutOfBounds && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                            <Button
                                type='primary'
                                onClick={handleBulkDownload}
                            >
                                Bulk Download Exports
                            </Button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
